const React = require('react');
const Ripple = require('../../Ripple');


module.exports = (props) => {
  return (
    <div>
      <Ripple
        disabled={props.disabled}
        onClick={props.onClick}
        className={`layoutRow fhaS fvaS hmin140 p10 pt20 rlv ov bs b1 r9
          dn bcCT f12 fw3 lh18 lts0em c0A tc bcF44A.error
          c0:not[.disabled]:h `
          + (props.error ? 'error ' : '')
          + (props.className || '')
        }
      >{props.children}</Ripple>
    </div>
  );
};
